import { Component, Input, OnInit } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-current-agent-states',
    templateUrl: './current-agent-states.component.html',
    styleUrls: ['./current-agent-states.component.scss']
})

export class CurrentAgentStatesComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    constructor(
        public config: CvConfigurationService
    ) {}

    ngOnInit(): void {}
}
